import { UsuarioReadingFiltersDtoProps } from "api/DTOs/UsuarioReadingFiltersDto"
import { SortingCriteria } from "api/interfaces/SortingCriteria"
import { ESTADO_PRESTAMO, EstadoPrestamoType } from "api/Types/EstadoPrestamo"
import { TIPO_PRESTAMO, TipoPrestamoType } from "api/Types/TipoPrestamo"
import { List } from "features/Contabilidad/pages/Prestamos/components/FilteredList/useFilteredList"

const ESTADO_PRESTAMO_DEFAULT: Record<EstadoPrestamoType, boolean> = {
  [ESTADO_PRESTAMO.PENDIENTE]: false,
  [ESTADO_PRESTAMO.EN_PROGRESO]: false,
  [ESTADO_PRESTAMO.COMPLETADO]: false,
} as const

const DEBTS_PRESTAMO_DEFAULT = {
  WITH_DEBT: false,
  WITHOUT_DEBT: false,
} as const

export const PRESTAMO_DEFAULT_FILTERS = {
  TAB_SELECTED: TIPO_PRESTAMO.CONCEDIDO as TipoPrestamoType,
  ESTADOS: ESTADO_PRESTAMO_DEFAULT,
  DEBTS: DEBTS_PRESTAMO_DEFAULT as Record<
    keyof typeof DEBTS_PRESTAMO_DEFAULT,
    boolean
  >,
  CURRENT_SHARE: false as boolean,
  DATES: { min: undefined, max: undefined } as Record<
    string,
    string | undefined
  >,
  AMOUNT: { min: undefined, max: undefined } as Record<
    string,
    number | undefined
  >,
  AMORTIZED_AMOUNT: { min: undefined, max: undefined } as Record<
    string,
    number | undefined
  >,
  PERSONALIZED_FIELDS: [] as Array<Record<string, string>>,
  LOAN_CREATOR: [] as List<UsuarioReadingFiltersDtoProps> | undefined,
  PAGINACION: {
    itemsPerPage: 100,
    skipCount: 0,
  } as {
    itemsPerPage: number
    skipCount: number
  },
  SORTING_CRITERIA: {
    property: undefined,
    sort: null,
  } as SortingCriteria,
  KEYWORD: "" as string,
} as const

export const resetFiltersSessionPrestamos = () => {
  sessionStorage.setItem(
    "filtroPrestamo",
    JSON.stringify(PRESTAMO_DEFAULT_FILTERS)
  )
}

export type PrestamoFiltersProps = typeof PRESTAMO_DEFAULT_FILTERS
